import blocksToHtml from '@sanity/block-content-to-html';

import BubbleButton from 'components/bubblebutton';
import Photo from 'components/photo';
import PortableText from 'components/portableText';
import Anchor from 'components/typography/anchor';
import config from 'siteconfig';
import { toPlainText } from 'utilities/blockText';
import { getRoute } from 'utilities/paths';

import TweetEmbed from './twitter';

const siteAddress = config.siteUrl;
const postImageWidth = 680;
const postImageSizes = '620px';
const postImageQuality = 80;

const postDetailSerializers = {
  block: {
    // Augment the built-in text styles like "normal" or "h1" here.
    small: ({ children }) => <small>{children}</small>,
  },
  types: {
    figure: (props) => {
      const caption = <PortableText blocks={props.value.caption} />;
      return (
        <Photo
          photo={props.value}
          width={postImageWidth}
          caption={caption}
          sizes={postImageSizes}
          quality={postImageQuality}
        />
      );
    },

    keywordRef: (props) => {
      return (
        <BubbleButton
          keyword={props.value.keyword.keyword}
          description={props.value.keyword.description}
        />
      );
    },
    twitter: (props) => {
      const tid = props?.value?.tweetId;
      return <TweetEmbed tid={tid}></TweetEmbed>;
    },
  },
  marks: {
    externalLink: (props) => {
      const { value, children } = props;
      const { href } = value;
      return <Anchor href={href}>{children}</Anchor>;
    },
    internalLink: (props) => {
      const { value, children } = props;
      let slug;
      if (value.reference._type === 'post') {
        slug = getRoute({
          publishedAt: value.reference.publishedAt,
          slug: value.reference.slug.current,
        });
      }
      return (
        <Anchor className="anchor-text" href={slug}>
          {children}
        </Anchor>
      );
    },
  },
};

const tileSerializers = {
  ...postDetailSerializers,
  ...{
    marks: {
      // Tile components shouldn't render a link in the description
      // FIXME: They probably shouldn't even support rich text of any kind..
      externalLink: (props) => props.children,
      internalLink: (props) => props.children,
    },
  },
};

// RSS Feed Serializers
// These need no visual style, so we use something barebones for feed rendering
const h = blocksToHtml.h;
const feedSerializers = {
  types: {
    figure: (props) =>
      h(
        'figure',
        h('img', { src: props.node.asset.url }, props.children),
        h('figcaption', toPlainText(props.node.caption))
      ),
    keywordRef: (props) => h('code', props.node.keyword.keyword),
    twitter: (props) =>
      h('iframe', {
        src: `https://platform.twitter.com/embed/index.html?embedId=twitter-widget-1&frame=false&hideCard=false&hideThread=false&id=${props.node.tweetId}&lang=en&siteScreenName=resistbot&theme=light&widgetsVersion=9066bb2%3A1593540614199&width=550px`,
      }),
  },
  marks: {
    externalLink: (props) =>
      h('a', { href: props.mark.href, alt: props.alt }, props.children),
    internalLink: (props) => {
      const { mark, children } = props;
      let slug;
      if (mark.reference._type === 'post') {
        slug = new URL(
          getRoute({
            publishedAt: mark.reference.publishedAt,
            slug: mark.reference.slug.current,
          }),
          siteAddress
        ).href;
      } else {
        slug = new URL(`/${mark.reference.slug.current}`, siteAddress).href;
      }
      return h('a', { href: slug }, children);
    },
  },
};

export { feedSerializers, postDetailSerializers, tileSerializers };
